import React from "react";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";

interface EmptyStateProps {
  icon: React.ComponentType<{ className?: string }>;
  title: string;
  actionLabel: string;
  onAction: () => void;
}

export const EmptyState: React.FC<EmptyStateProps> = React.memo(
  ({ icon: Icon, title, actionLabel, onAction }) => (
    <div className="flex flex-col h-[calc(100vh-8rem)] items-center justify-center text-center">
      <Icon className="w-8 h-8 text-secondary-n-400 mb-3" />
      <p className="text-lg text-secondary-n-400 mb-4">{title}</p>
      <Button
        size="sm"
        variant="primary"
        onClick={onAction}
        className="text-xs"
      >
        <Plus className="w-4 h-4 mr-1" />
        {actionLabel}
      </Button>
    </div>
  ),
);

EmptyState.displayName = "EmptyState";
